module.exports = __webpack_public_path__ + "img/ltkbeauty-1x.3c32e5e.jpg";